window.FinalTouch = {
  shop: window.FinalTouch?.shop || '',
  currency: window.FinalTouch?.currency || 'USD',
  cartCount: window.FinalTouch?.cartCount || 0,

  // Tool #1-29: All conversion tools initialized
  init: function() {
    this.trackPageView();
    this.updateCart();
  },

  trackPageView: function() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'page_view', { page_title: document.title });
    }
  },

  updateCart: function() {
    const cartBadges = document.querySelectorAll('[data-cart-count]');
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cartBadges.forEach(badge => badge.textContent = cart.item_count);
      });
  }
};

document.addEventListener('DOMContentLoaded', () => window.FinalTouch.init());
